<template>
  <div>
    <case-header
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :productType="productType"
      :logo="logo"
      :titleObj="titleObj"
    >
    </case-header>
    <!-- <div>
      <p>{{gae}}</p>
      <div @click="gae++">znejia</div>
    </div> -->
    <keep-alive>
      <case-center-new 
        :type="caseType"
        :cases="casesList"
        ref="caseRef">
      </case-center-new>
    </keep-alive>
    <!-- <case-center
      :type="caseType"
      :cases="casesList"
      ref="caseRef"
    ></case-center> -->
    <case-footer
      :bottomNews="bottomNews"
      :bottom="bottom"
      :bottomInfo="bottomInfo"
      :productType="productType"
    >
    </case-footer>
  </div>
</template>

<script>
import Swiper from "swiper";
import CaseHeader from "@/components/pc/Header";
import CaseCenter from "@/components/pc/CaseCenter";
import CaseCenterNew from "@/components/pc/CaseCenterNew";
import CaseFooter from "@/components/pc/Footer";
export default {
  name: "Cases",
  data() {
    return {
      gae:1,
      screenStyle: {
        width: "",
        margin: "0 auto",
      },
      actIndex: 4,
      topStyle: "",
      imgList: [],
      bottom: {},
      logo: "",
      bottomInfo: {},
      caseType: [],
      casesList: [],
      productType: [],
      bottomNews: [],
      titleObj: {
        title: "案例中心",
        desc:
          "多种平台与开发技术上大量案例的积累,是我们为您提供\n优质开发服务的底气",
      },
    };
  },
  components: {
    CaseHeader,
    CaseCenter,
    CaseFooter,
    CaseCenterNew
  },
  mounted() {
    this.Pc_Mobile();
    this.getPageData();
    this.getHeaderImage();
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    Pc_Mobile() {
      if (this._isMobile()) {
        this.$router.push("/m_cases");
      } else {
        this.$router.push("/cases");
      }
    },
    
  
    
        imgSwiper () {
            var swiper = new Swiper('.cases-swiper-container', {
                slidesPerView: 1,
                noSwiping : true,
                navigation: {
                    nextEl: '.cases-swiper-button-next',
                    prevEl: '.cases-swiper-button-prev',
                },
                pagination: {
                    el: '.cases-swiper-pagination',
                    type: 'fraction'
                },
                observer:true,//修改swiper自己或子元素时，自动初始化swiper
                observeParents:false,//修改swiper的父元素时，自动初始化swiper
                onSlideChangeEnd: function(swiper){
                    swiper.update();  
                    mySwiper.startAutoplay();
                    mySwiper.reLoop();  
                }
                // autoHeight: true,
            });
        },
    getPageData() {
      this.$http.post("home/index/cases", null, (res) => {
        // console.log(res.data)
        let newRes= res.data
        this.bottom = newRes.data.bottom[0];
        // this.logo = this.bottom.logo;

        this.bottomInfo = newRes.data.contact[0];
        this.caseType = newRes.data.type;
        this.casesList = newRes.data.case;
        this.productType = newRes.data.cp_type;
        // console.log(newRes, "oiqiu");
        this.bottomNews = newRes.data.b_news;
        this.$nextTick(() => {
          this.$refs.caseRef.imgSwiper();
          // this.$refs.teamRef.imgSwiper()
        });
      });
    },
    getHeaderImage() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/special",
        { type_two: this.actIndex },
        (res) => {
          if (res.code == 1) {
            this.topStyle = "background-image:url('" + res.data.pc_image + "')";
          }
        }
      );
    },
  },
};
</script>

<style lang="stylus" scoped>

</style>


// WEBPACK FOOTER //
// src/views/pc/Cases.vue